import { useEffect, useState } from 'react';
const MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
const getInitialPreference = () => {
    if (typeof window === 'undefined' || !window.matchMedia) {
        return false;
    }
    return window.matchMedia(MEDIA_QUERY).matches;
};
export function useReducedMotion() {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(getInitialPreference);
    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return undefined;
        }
        const mediaQueryList = window.matchMedia(MEDIA_QUERY);
        const handler = (event) => {
            setPrefersReducedMotion(event.matches);
        };
        // Modern API
        if ('addEventListener' in mediaQueryList) {
            mediaQueryList.addEventListener('change', handler);
            return () => mediaQueryList.removeEventListener('change', handler);
        }
        // Legacy API fallback (Safari < 14)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const legacyMql = mediaQueryList;
        legacyMql.addListener(handler);
        return () => legacyMql.removeListener(handler);
    }, []);
    return prefersReducedMotion;
}
//# sourceMappingURL=useReducedMotion.js.map